import { createExternalModalPath } from '@routing/appUrls';
import { useSetAtom } from 'jotai';
import { externalViewModalDataAtom } from '@js/store/modalAtoms';
import { ModalPropsMap, ModalType } from '@models/modals/Modals';

export type ExternalModalName = ModalType.LinkDocuments;

const useOpenModalInExternalView = () => {
    const setExternalViewModalData = useSetAtom(externalViewModalDataAtom);

    return <T extends ExternalModalName>(modalName: T, data: ModalPropsMap[T]) => {
        const width = window.innerWidth;
        const height = window.innerHeight;
        const features = `location,toolbar,scrollbars,resizable,top=40,left=40,
            width=${width},height=${height}`;
        setExternalViewModalData(data);
        window.open(createExternalModalPath(modalName), 'modalExternalView', features);
    };
};

export default useOpenModalInExternalView;
